import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=d332a804&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d332a804",
  null
  
)

export default component.exports